// extracted by mini-css-extract-plugin
export default {"tabs":"TopRateTabs_tabs__bQzEb","tab":"TopRateTabs_tab__I3byR","active":"TopRateTabs_active__FWlhN"};